import API from './api';

type PayloadResendEmail = {
  id: number;
  email_address: string;
};

export const resendConfirmationEmail = ({ id, email_address }: PayloadResendEmail) => API.put(`/account_holders/${id}/send_confirmation_email`, { email_address });
